import { Outlet } from 'react-router-dom';
import { Sidebar, Navbar } from '../components';
import { useStateContext } from '../contexts/ContextProvider';
import { useLiveUpdates } from "../utils/customHooks";

import sidebarCollapsibleBrownButton from '../assets/images/sidebar_collapse_icon_brown.svg';
import sidebarSubmenuIcon from '../assets/images/side_bar_sub_menu_icon.svg';

const Layout = () => {
  const { activeMenu, setActiveMenu } = useStateContext();
  
  useLiveUpdates();

  return (
    <div className="h-screen">
      <div className="flex relative h-full">
        {activeMenu ? (
          <div className="w-[220px] fixed sidebar z-[2]">
            <Sidebar />
            <span className='cursor-pointer' onClick={() => setActiveMenu(!activeMenu)}>
              <img className='absolute left-[220px] top-2 -translate-x-4 rotate-180' src={sidebarCollapsibleBrownButton} alt='' />
              <img className='absolute left-[218px] top-6 rotate-90 -translate-x-[13px]' src={sidebarSubmenuIcon} alt='' />
            </span>
          </div>
        ) : (
          <div className="w-[84px] fixed sidebar z-[2] bg-[#161e29]">
            <Sidebar />
            <span className='cursor-pointer' onClick={() => setActiveMenu(!activeMenu)}>
              <img className='absolute left-[84px] top-2 -translate-x-4 rotate-180' src={sidebarCollapsibleBrownButton} alt='' />
              <img className='absolute left-[84px] top-6 -rotate-90 -translate-x-[14px]' src={sidebarSubmenuIcon} alt='' />
            </span>
          </div>
        )}
        <div className={
          ` bg-white w-full z-[1] relative 
           ${activeMenu
            ? 'md:ml-56'
            : 'md:ml-20'}`
        }>
          <div className="top-0 relative bg-white w-full border-b-1 shadow-sm flex justify-between mr-auto">
            <Navbar />
          </div>
          <div className='bg-white mt-1 pt-2 w-full mainContent'>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Layout;